<template>
  <v-container class="px-0 py-0">
    <v-form ref="analiticoFilterForm">
      <v-row class="pa-0">
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Prestador</label>
          <v-autocomplete
            v-model="formData.prestador_id"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            small-chips
            :disabled="prestadoresFilter.length == 1"

            :search-input.sync="searchInput"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllPrestadores">
                <v-list-item-content>
                  <v-list-item-title>{{
                    isAllPrestadoresSelected ? "NENHUM" : "TODOS"
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="data">
              <span v-if="isAllPrestadoresSelected && data.index == 0">TODOS</span>
              <v-chip
                v-if="!isAllPrestadoresSelected && data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.prestador_id.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.prest_nome }}</v-chip
              >
              <span v-if="!isAllPrestadoresSelected && data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.prestador_id.length == 3
                    ? formData.prestador_id.length - 2 + " outro"
                    : formData.prestador_id.length - 2 + " outros"
                }})
              </span>
            </template>
            <template v-slot:item="data">
                  <v-list-item
                    @click="toggleAutocomplete(data.item, 'prestador_id')"
                    :class="
                      formData.prestador_id.includes(data.item.id)
                        ? 'primary--text v-list-item--active'
                        : ''
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.prest_nome
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Operadoras</label>
          <v-autocomplete
            v-model="formData.operadora_ans_id"
            :items="operadorasFilter"
            item-value="id"
            item-text="oper_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :search-input.sync="searchInput"
          >
          <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllOperadoras">
                <v-list-item-content>
                  <v-list-item-title>{{
                    isAllOperadorasSelected ? "NENHUM" : "TODOS"
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="data">
              <span v-if="isAllOperadorasSelected && data.index == 0">TODOS</span>
              <v-chip
                 v-if="!isAllOperadorasSelected && data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.operadora_ans_id.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.oper_nome }}</v-chip
              >
              <span v-if="!isAllOperadorasSelected && data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.operadora_ans_id.length == 3
                    ? formData.operadora_ans_id.length - 2 + " outro"
                    : formData.operadora_ans_id.length - 2 + " outros"
                }})
              </span>
            </template>
            <template v-slot:item="data">
                  <v-list-item
                    @click="toggleAutocomplete(data.item, 'operadora_ans_id')"
                    :class="
                      formData.operadora_ans_id.includes(data.item.id)
                        ? 'primary--text v-list-item--active'
                        : ''
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.oper_nome
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="px-0 py-0">
        <v-col cols="12" sm="6" md="3">
          <label>Tipo de data</label>
          <v-select
            v-model="formData.tipo_data"
            :items="[
              { id: 'dt_faturamento', descricao: 'Cobrança' },
              { id: 'dt_prev_vencimento', descricao: 'Vencimento' }
            ]"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span>Data entre</span><br>
          <v-menu
            ref="dtPublicacaoI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateInicioIFormatted"
                dense
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_inicio = parseDate(dateInicioIFormatted)"
                :rules="formData.data_inicio == null ? [formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="dataMinima"
              :max="formData.data_fim"
              v-model="formData.data_inicio"
              @input="dateInicioIFormatted = formatDate(formData.data_inicio)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            ref="dtPublicacaoF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateInicioFFormatted"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_fim = parseDate(dateInicioFFormatted)"
                :rules="formData.data_inicio == null ?[formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="formData.data_inicio"
              v-model="formData.data_fim"
              @input="dateInicioFFormatted = formatDate(formData.data_fim)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer/>
          <v-col cols="12" sm="3" class="py-8 text-right">
          <v-btn
            class="mt-0"
            height="31px"
            small
            depressed
            color="primary"
            @click="sendFilter(true)"
            >Solicitar Relatório</v-btn
          >
          <v-btn
            class="mt-0 ml-4"
            height="31px"
            small
            depressed
            outlined
            color="primary"
            @click="clearFilters()"
            >Limpar Filtros</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
// import moment from "moment";
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
export default {
  directives: {
    mask,
  },
  data() {
    return {
      dataMinima: '2022-01-01',
      formData: {
        data_fim: null,
        data_inicio: null,
        modulo_operadora: "faturamento",
        tipo_data: "dt_faturamento",
        operadora_ans_id: [],
        prestador_id: []
      },
      dateFFormatted: null,
      dateIFormatted: null,
      dateInicioFFormatted: null,
      dateInicioIFormatted: null,
      prestadoresFilter: [],
      operadorasFilter: [],
      responsaveisFilter: [],
      searchInput: null
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
    isAllPrestadoresSelected() {
      if (this.formData && this.formData.prestador_id) {
        return this.prestadoresFilter.length == this.formData.prestador_id.length;
      } else {
        return false;
      }
    },
    isAllOperadorasSelected() {
      if (this.formData && this.formData.operadora_ans_id) {
        return this.operadorasFilter.length == this.formData.operadora_ans_id.length;
      } else {
        return false;
      }
    },
  },
  methods: {
    clearFilters() {
      this.dateFFormatted = null;
      this.dateIFormatted = null;
      this.formData.data_fim = null;
      this.formData.data_inicio = null;
      this.dateInicioFFormatted = null;
      this.dateInicioIFormatted = null;
      this.formData.operadora_ans_id = [];
      if (this.prestadoresFilter.length > 1) {
        this.formData.prestador_id = [];
      }
      this.$refs.analiticoFilterForm.resetValidation()
    },
    changePrestador() {
      this.formData.operadora_ans_id = null;
      let {modulo_operadora, prestador_id} = this.formData
      this.getOperadoras({
        modulo_operadora,
        prestador_ids: prestador_id
      });
    },
    sendFilter() {
      if(this.formData.data_inicio == null &&
          this.formData.data_fim == null
      ){
              let paramModal = {
              type: "info",
              title: "Atenção:",
              message: "Selecione o período de tempo.",
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Cancelar", show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
      if(this.$refs.analiticoFilterForm.validate()) {
        if ( !this.formData.data_fim && this.formData.data_inicio ) {
          this.dateF = this.formData.data_inicio;
          this.formData.data_fim = this.formData.data_inicio;
        }
        this.updateFilter(this.formData);
      }
    },
    toggleAllOperadoras() {
      this.searchInput = null;
      if (!this.isAllOperadorasSelected) {
        this.formData.operadora_ans_id = this.operadorasFilter.map((el) => el.id);
      } else {
        this.formData.operadora_ans_id = [];
      }
    },
    toggleAllPrestadores() {
      this.searchInput = null;
      if (!this.isAllPrestadoresSelected) {
        this.formData.prestador_id = this.prestadoresFilter.map((el) => el.id);
      } else {
        this.formData.prestador_id = [];
      }
    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null
      let index = this.formData[campo].indexOf(item.id);
      //  index > -1  está excluindo o item
      if (index > -1) {
        this.formData[campo].splice(index, 1);
      } else {
        //  index < 0  está adicionando o item
        this.formData[campo].push(item.id);
      }
      this.$nextTick();
      return;
    },
  },
  props: {
    filter: Object,
    formatDate: Function,
    grupoEconomico: Number,
    updateFilter: Function,
    getOperadoras: Function,
    operadoras: Array,
    parseDate: Function,
    prestadores: Array,
    validarForm: Boolean,
    parametros: Object
  },
  beforeMount() {
    if(this.parametros && this.parametros.REL_ANALITICO_FATURAMENTO_DATA_CORTE != null){
      this.dataMinima = this.parametros.REL_ANALITICO_FATURAMENTO_DATA_CORTE
    }
  },
  mounted() {
    this.prestadoresFilter = Array.from(this.prestadores);
    if (this.prestadoresFilter.length == 1) {
      this.formData.prestador_id = [this.prestadores[0].id];
    }
  },
  watch: {
    dateFFormatted(val) {
      if (!val) {
        this.formData.data_fim = null;
      } else {
        if (
          !!this.formData.data_inicio &&
          Date.parse(this.formData.data_inicio) >
            Date.parse(this.parseDate(val))
        ) {
          this.dateIFormatted = val;
          this.formData.data_inicio = this.parseDate(val);
        }
        this.formData.data_fim = this.parseDate(val);
      }
    },
    dateIFormatted(val) {
      if (!val) {
        this.formData.data_inicio = null;
      } else {
        if (
          !!this.formData.data_fim &&
          Date.parse(this.formData.data_fim) <
            Date.parse(this.parseDate(val))
        ) {
          this.dateFFormatted = val;
          this.formData.data_fim = this.parseDate(val);
        }
        this.formData.data_inicio = this.parseDate(val);
      }
    },
    operadoras: {
      deep: true,
      handler(val) {
        this.operadorasFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.operadora_ans_id = val[0].id;
        }
      },
    },
    prestadores: {
      deep: true,
      handler(val) {
        this.prestadoresFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.prestador_id = [val[0].id];
        }
      },
    },
    validarForm: {
      handler(val) {
        if (val) {
          this.sendFilter(false);
        }
      },
    },
    parametros: {
      handler(val) {
        if(val && val.REL_ANALITICO_FATURAMENTO_DATA_CORTE != null){
          this.dataMinima = val.REL_ANALITICO_FATURAMENTO_DATA_CORTE
        }
      }
    }
  },
};
</script>
